const filterElementNode = (node: ChildNode) => node.nodeType === 1;

export const getDisclosureGroups = (nodes?: NodeListOf<ChildNode>) => {
  const details = Array.from(nodes ?? []).filter(filterElementNode);

  const triggers = [];
  const content: string[] = [];
  const expandedKeys: string[] = [];

  const keyPrefix = 'disclosure';

  for (const detail of details) {
    if (detail.nodeName.toLowerCase() === 'dt') {
      triggers.push(detail.textContent ?? '');
    } else if (detail instanceof Element) {
      const html = detail.outerHTML;
      if (!html.includes('hidden="until-found"')) {
        expandedKeys.push(`${keyPrefix}${triggers.length - 1}`);
      }
      content.push(
        html.replace(/\n\s*/g, '').replace(' hidden="until-found"', ''),
      );
    }
  }

  return {
    expandedKeys,
    groups: triggers.map((trigger, idx) => ({
      content: content[idx],
      expandedKeys,
      key: `${keyPrefix}${idx}`,
      triggerText: trigger,
    })),
  };
};
